// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"5a2fefa7","929":"8599e4b7"}[chunkId] + ".chunk.css";
};